export default function createStateGetter(Collection) {
  return () => {
    throw new Error(`Cannot get state for ${Collection.name}`);
  };
}
